import Vue from "vue";

export default class CoursePackageApi {

    constructor(api) {
        this.api = api;
    }

    getAll(callback, error) {
        this.api.getRaw((axios) => {
            axios.get("coursePackage").then((response) => {
                callback(response.data.map((date) => date));
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    delete(name, callback, error) {
        this.api.getRaw((axios) => {
            axios.delete("coursePackage/" + name).then(() => {
                callback();
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    upload(file, progress, callback, error) {
        let formData = new FormData();
        formData.append("file", file);
        this.api.getRaw((axios) => {
            axios.post("coursePackage", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: progress
            }, (newProgress) => {
                console.log(newProgress)
                progress(newProgress)
            }).then(() => {
                callback();
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }
}
